import ProjectGroup from '../project-group';

/**
 * Create the action
 */

const { thunk, request, success, error } = ProjectGroup.update(({ id, ...data }, fetch) => {
    
    // Prepare request
    let formData = new FormData();
    formData.append('_method', 'PUT');
    ['membership']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(`/project-groups/${id}`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
